import { Component, OnInit, TemplateRef, EventEmitter } from '@angular/core';

@Component({
  selector: 'fgbcl-confirm-modal',
  templateUrl: './confirm-modal.component.html',
  styleUrls: ['./confirm-modal.component.scss'],
})
export class ConfirmModalComponent implements OnInit {
  imageRef: TemplateRef<any>;
  modalContent: TemplateRef<any>;
  context: any;
  headerContent: { icon: string; data: string };
  confirm = new EventEmitter<string>();
  close = new EventEmitter<string>();

  constructor() {}

  ngOnInit() {}
}
